import {getCompany } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const fetchAllCompany = (search = "") => {
    return dispatch => {
        dispatch({type:"Company_ACTION_START"})
        getCompany(search).then((result)=>{
            dispatch({
                type: "Company_FETCH_DATA",
                payload: result?.data?.getCompany || []
            }) 
        }).catch((error)=>{
            dispatch({
                type: "Company_FETCH_DATA_FAILED",
                payload: error?.response?.data?.error || error?.message
            }) 
        });
    }
}
